module.exports = __webpack_public_path__ + "img/mol.aa5555fd.png";